import {Link} from '@jobseeker/lotus/elements';
import {cleanUrl} from '@jobseeker/lotus/utils';
import {Box, List, ListItem, Typography} from '@mui/material';

const JobsByLocation = () => {
  // TODO: Fetch this cities list from API
  const CITIES = [
    'Bangalore',
    'Mumbai',
    'Delhi NCR',
    'Noida',
    'Gurgaon/Gurugram',
    'Hyderabad',
    'Chennai',
    'Coimbatore',
    'Pune',
    'Kolkata',
  ];

  return (
    <Box
      sx={{
        // backgroundImage:
        //   'url(https://job-static.hirist.com/V8/static/media/jobs-by-location-background.dc51eabc.svg)',
        // backgroundRepeat: 'no-repeat',
        // backgroundPosition: 'bottom',
        p: 0,
        pt: 2.5,
        bgcolor: 'white',
        borderRadius: '8px',
        mb: 3.75,
        backgroundImage:
          'url(https://job-static.hirist.com/V8/static/media/jobs-by-location-background.dc51eabc.svg)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
      }}
    >
      <Typography component="h2" pl={2.5}>
        Jobs by location
      </Typography>
      <List
        sx={{
          listStyleType: 'disc',
          pl: 4.5,
          '& .MuiListItem-root': {
            display: 'list-item',
          },
        }}
      >
        {CITIES.map((city, idx) => (
          <ListItem key={idx} sx={{p: 0}}>
            <Link
              sx={{p: 0, fontSize: 14, ':hover': {cursor: 'pointer'}}}
              href={`${
                process.env.NEXT_PUBLIC_LOAD_CONFIG
              }/it-jobs-in-${cleanUrl(city)}?source=jdLocationBlock`}
              target="_blank"
            >
              Jobs in {city}
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default JobsByLocation;
